import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import ListCtgsPage from './list';
// import EditCategoryPage from './edit';

const CategoriesRoutingPages = ({ match }) => (
  <Suspense fallback={<div className="loading" />}>
    <Switch>
        <Redirect exact from={`${match.url}/`} to={`${match.url}/list`} />

        <Route path={`${match.url}/list`}
          render={props => <ListCtgsPage {...props} />}
        />

        {/* <Route path={`${match.url}/edit/:userId`}
          render={props => <EditClientPage {...props} />}
        /> */}

        <Redirect from={`${match.url}/`} to={`${match.url}/list`} />
        <Redirect to="/error" />
      </Switch>
    
  </Suspense>
);
export default CategoriesRoutingPages;
